import includes from 'lodash/includes'
import isPlainObject from 'lodash/isPlainObject'
import type { PivotLayout } from '@ztechapps/common.contract'
import { PivotChartTypeEnum, PivotGrandTotalsEnum } from '@ztechapps/common.contract'
import { jsonTryParse } from '@ztechapps/common.utils'
import { EMPTY_PIVOT_LAYOUT } from './constants'
import { prunePivotValueFilters } from './pivotLayout.utils'

/** Parses a stored pivot layout, falling back to the empty layout. */
export const parsePivotLayout = (value?: string): PivotLayout => {
  const parsed = jsonTryParse(value)
  if (!isPlainObject(parsed)) return EMPTY_PIVOT_LAYOUT
  const source = parsed as Partial<PivotLayout>
  return prunePivotValueFilters({
    rows: Array.isArray(source.rows) ? source.rows : [...EMPTY_PIVOT_LAYOUT.rows],
    columns: Array.isArray(source.columns) ? source.columns : [...EMPTY_PIVOT_LAYOUT.columns],
    measures: Array.isArray(source.measures) ? source.measures : [...EMPTY_PIVOT_LAYOUT.measures],
    filters: Array.isArray(source.filters) ? source.filters : [...EMPTY_PIVOT_LAYOUT.filters],
    memberSorts: Array.isArray(source.memberSorts) ? source.memberSorts : [...EMPTY_PIVOT_LAYOUT.memberSorts],
    columnWidths: Array.isArray(source.columnWidths) ? source.columnWidths : [...EMPTY_PIVOT_LAYOUT.columnWidths],
    ...(isPlainObject(source.valueSort) ? { valueSort: source.valueSort } : {}),
    showSubtotals: typeof source.showSubtotals === 'boolean' ? source.showSubtotals : EMPTY_PIVOT_LAYOUT.showSubtotals,
    showGrandTotals: includes(PivotGrandTotalsEnum, source.showGrandTotals)
      ? (source.showGrandTotals as PivotGrandTotalsEnum)
      : EMPTY_PIVOT_LAYOUT.showGrandTotals,
    expandAll: typeof source.expandAll === 'boolean' ? source.expandAll : EMPTY_PIVOT_LAYOUT.expandAll,
    ...(includes(PivotChartTypeEnum, source.chartType) ? { chartType: source.chartType } : {}),
  })
}
